/* global axios */

import ApiClient from './ApiClient';

class InstagramCommentAutomationsAPI extends ApiClient {
  constructor() {
    super('instagram_comment_automations', { accountScoped: true });
  }

  inboxUrl(inboxId) {
    return `${this.baseUrl()}/inboxes/${inboxId}/instagram_comment_automations`;
  }

  get(inboxId) {
    return axios.get(this.inboxUrl(inboxId));
  }

  create(inboxId, data) {
    return axios.post(this.inboxUrl(inboxId), data);
  }

  update(inboxId, id, data) {
    return axios.patch(`${this.inboxUrl(inboxId)}/${id}`, data);
  }

  delete(inboxId, id) {
    return axios.delete(`${this.inboxUrl(inboxId)}/${id}`);
  }
}

export default new InstagramCommentAutomationsAPI();
